/* ============================================================
   Dolcefrotto — Tuch fliegt in den Warenkorb
   Bei jedem erfolgreichen "In den Warenkorb" (Produktseite,
   Set, Vorschläge im Warenkorb) faltet sich ein kleines Tuch
   mit dem Produktbild zweimal und fliegt zum Warenkorb-Symbol.
   - Hört nur auf erfolgreiche Antworten von /cart/add.
   - Ändert keine Warenkorb-Logik, speichert nichts, kein Tracking.
   - Bei "Bewegung reduzieren" passiert nichts.
   ============================================================ */
(() => {
  if (window.__dfFlyTowel) return;
  window.__dfFlyTowel = true;

  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || typeof Element.prototype.animate !== 'function') return;

  /* Letzter angetippter Button: Startpunkt der Animation */
  let lastPress = null;
  const remember = (event) => {
    const el = event.target && event.target.closest
      ? event.target.closest('button, [type="submit"], [data-dfu-add], [data-dfb-add], a')
      : null;
    if (el) lastPress = { el, time: Date.now() };
  };
  document.addEventListener('pointerdown', remember, true);
  document.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') remember(e); }, true);
  document.addEventListener('submit', (e) => {
    const btn = e.submitter || (e.target && e.target.querySelector && e.target.querySelector('[type="submit"]'));
    if (btn) lastPress = { el: btn, time: Date.now() };
  }, true);

  const isAdd = (url) => /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));

  /* fetch umhüllen: nur beobachten, Antwort unverändert weitergeben */
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    const promise = nativeFetch.apply(this, arguments);
    if (method === 'POST' && isAdd(url)) {
      const press = lastPress;
      promise.then((res) => {
        if (res && res.ok) {
          /* Status-Antworten wie 422 sind nicht ok; 200 = hinzugefügt */
          requestAnimationFrame(() => fly(press));
        }
      }).catch(() => {});
    }
    return promise;
  };

  function findImage(press) {
    const el = press && Date.now() - press.time < 8000 ? press.el : null;
    const scopes = [
      el && el.closest('.dfu-card, .dfb-pick, .dfb-card, .card-wrapper, .card, li'),
      el && el.closest('product-info, .product, [id^="MainProduct"]'),
      document.querySelector('product-info .product__media img, .product__media-item img, .product__media img'),
    ];
    for (const scope of scopes) {
      if (!scope) continue;
      const img = scope.tagName === 'IMG' ? scope : scope.querySelector('img');
      if (img && (img.currentSrc || img.src)) return img.currentSrc || img.src;
    }
    return '';
  }

  function startRect(press) {
    const el = press && Date.now() - press.time < 8000 ? press.el : null;
    if (el && el.isConnected) {
      const r = el.getBoundingClientRect();
      if (r.width && r.bottom > 0 && r.top < window.innerHeight) return r;
    }
    const w = window.innerWidth;
    const h = window.innerHeight;
    return { left: w / 2 - 60, top: h * 0.6, width: 120, height: 48 };
  }

  function targetRect() {
    const icons = document.querySelectorAll('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]');
    for (const icon of icons) {
      const r = icon.getBoundingClientRect();
      if (r.width && r.height && r.top >= -4 && r.bottom <= window.innerHeight + 4) return { rect: r, icon };
    }
    /* Kopfzeile ausgeblendet (beim Scrollen): oben rechts landen */
    const w = window.innerWidth;
    return { rect: { left: w - 44, top: 12, width: 28, height: 28 }, icon: null };
  }

  function build(src, w, h) {
    const towel = document.createElement('div');
    towel.setAttribute('aria-hidden', 'true');
    towel.className = 'df-fly';
    const face = src
      ? `url("${src.replace(/"/g, '%22')}") center / cover no-repeat`
      : 'repeating-linear-gradient(90deg,#252525 0 10px,#f8f8f8 10px 20px)';
    towel.innerHTML =
      '<span class="df-fly__half df-fly__left"></span>' +
      '<span class="df-fly__half df-fly__right"><i class="df-fly__front"></i><i class="df-fly__back"></i></span>';
    Object.assign(towel.style, {
      position: 'fixed', left: '0', top: '0', width: `${w}px`, height: `${h}px`,
      zIndex: '2147483000', pointerEvents: 'none', perspective: '600px',
      transformOrigin: '50% 50%', willChange: 'transform, opacity',
    });
    const halves = towel.querySelectorAll('.df-fly__half');
    halves.forEach((half) => Object.assign(half.style, {
      position: 'absolute', top: '0', width: '50%', height: '100%', display: 'block',
      transformStyle: 'preserve-3d', borderRadius: '3px',
    }));
    const left = towel.querySelector('.df-fly__left');
    const right = towel.querySelector('.df-fly__right');
    left.style.left = '0';
    left.style.background = face;
    left.style.backgroundSize = '200% 100%';
    left.style.backgroundPosition = '0 50%';
    left.style.boxShadow = '0 6px 16px rgba(0,0,0,.18)';
    right.style.left = '50%';
    right.style.transformOrigin = '0 50%';
    const front = towel.querySelector('.df-fly__front');
    const back = towel.querySelector('.df-fly__back');
    [front, back].forEach((f) => Object.assign(f.style, {
      position: 'absolute', inset: '0', backfaceVisibility: 'hidden', WebkitBackfaceVisibility: 'hidden', borderRadius: '3px',
    }));
    front.style.background = face;
    front.style.backgroundSize = '200% 100%';
    front.style.backgroundPosition = '100% 50%';
    back.style.background = 'linear-gradient(90deg,#e9e6e1,#f8f8f8)';
    back.style.transform = 'rotateY(180deg)';
    back.style.boxShadow = 'inset 0 0 0 1px rgba(37,37,37,.08)';
    return { towel, right };
  }

  function fly(press) {
    try {
      const small = window.innerWidth < 750;
      const w = small ? 96 : 132;
      const h = Math.round(w * 0.56);
      const from = startRect(press);
      const { rect: to, icon } = targetRect();
      const x0 = from.left + from.width / 2 - w / 2;
      const y0 = from.top + from.height / 2 - h / 2;
      const x1 = to.left + to.width / 2 - w / 2;
      const y1 = to.top + to.height / 2 - h / 2;

      const { towel, right } = build(findImage(press), w, h);
      document.body.appendChild(towel);

      /* 1) Tuch erscheint und faltet sich längs (rechte Hälfte klappt über) */
      const fold = 260;
      const travel = small ? 620 : 720;
      towel.animate(
        [
          { transform: `translate(${x0}px, ${y0}px) scale(.6)`, opacity: 0 },
          { transform: `translate(${x0}px, ${y0 - 18}px) scale(1)`, opacity: 1 },
        ],
        { duration: 160, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' }
      );
      right.animate(
        [{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(-180deg)' }],
        { duration: fold, delay: 140, easing: 'cubic-bezier(.5,0,.2,1)', fill: 'forwards' }
      );

      /* 2) zweite Faltung (quer) und Flug im Bogen zum Warenkorb */
      const steps = 14;
      const lift = Math.max(60, Math.min(220, Math.abs(y0 - y1) * 0.5 + 60));
      const midX = (x0 + x1) / 2;
      const midY = Math.min(y0, y1) - lift;
      const frames = [];
      for (let i = 0; i <= steps; i += 1) {
        const t = i / steps;
        const x = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * midX + t * t * x1;
        const y = (1 - t) * (1 - t) * (y0 - 18) + 2 * (1 - t) * t * midY + t * t * y1;
        const fy = i === 0 ? 1 : 0.5; /* quer gefaltet */
        const s = 1 - t * 0.72;
        const rot = Math.sin(t * Math.PI) * -14;
        frames.push({
          transform: `translate(${x}px, ${y}px) rotate(${rot}deg) scale(${s}, ${s * fy})`,
          opacity: t > 0.9 ? 1 - (t - 0.9) * 8 : 1,
          offset: t,
        });
      }
      const flight = towel.animate(frames, {
        duration: travel,
        delay: 140 + fold,
        easing: 'cubic-bezier(.45,0,.25,1)',
        fill: 'forwards',
      });

      flight.finished.then(() => {
        towel.remove();
        if (icon) {
          icon.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.22)' }, { transform: 'scale(.94)' }, { transform: 'scale(1)' }],
            { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' }
          );
        }
      }).catch(() => towel.remove());
      /* Sicherheitsnetz, falls die Animation abgebrochen wird */
      setTimeout(() => towel.isConnected && towel.remove(), 2200);
    } catch (error) {
      /* Animation ist Dekoration: Fehler nie an den Kunden weitergeben */
    }
  }
})();
